var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('swiper',{attrs:{"type":5}}),_c('join')],1)}
var staticRenderFns = []

export { render, staticRenderFns }